import { Injectable } from '@angular/core';
import { WebViewBackground } from '@rsg/capacitor-webview-background';
import { COLOR } from '../../utils/theme.utils';

@Injectable({
  providedIn: 'root'
})
export class WebViewService {
  async setBackgroundColor(color: COLOR) {
    const options = {
      color
    };

    await WebViewBackground.setBackgroundColor(options);
  }
}
